import React from "react";
import { Box, Typography, Divider, useTheme } from "@mui/material";
import Header from "../../../components/Header";
import { useNavigate, useParams } from "react-router-dom";
import ErrorComponent from "../../../components/ErrorComponent";
import LoadingComponent from "../../../components/LoadingComponent";
import { tokens } from "../../../theme";
import SuccessButton from "../../../components/SuccessButton";
import { useGetPurchaseByIdQuery } from "../../../services/inventoryService";
import ProductsList from "../../../components/ProductsList";
import { formatDate } from "../../../utils/formatDate";

const ViewPurchase = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: purchase, isLoading, error } = useGetPurchaseByIdQuery(id);
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  if (isLoading) return <LoadingComponent />;
  if (error) return <ErrorComponent />;

  return (
    <Box m="20px">
      <Header title="Detalles de la Compra" />

      <Box
        display="grid"
        gap="20px"
        gridTemplateColumns="repeat(5, minmax(0, 1fr))"
      >
        {/* Receipt Number */}
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" color={colors.greenAccent[500]}>
            Número de Factura
          </Typography>
          <Typography variant="body1" color={colors.grey[100]}>
            {purchase?.number}
          </Typography>
        </Box>

        {/* Supplier */}
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" color={colors.greenAccent[500]}>
            Proveedor
          </Typography>
          <Typography variant="body1" color={colors.grey[100]}>
          {purchase?.supplier}
          </Typography>
        </Box>

        {/* Date */}
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" color={colors.greenAccent[500]}>
            Fecha
          </Typography>
          <Typography variant="body1" color={colors.grey[100]}>
            {formatDate(purchase?.date)}
          </Typography>
        </Box>

        {/* Products Quantity */}
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" color={colors.greenAccent[500]}>
            Productos Comprados
          </Typography>
          <Typography variant="body1" color={colors.grey[100]}>
            {purchase?.number_of_products}
          </Typography>
        </Box>

        {/* Total Cost */}
        <Box>
          <Typography variant="subtitle1" fontWeight="bold" color={colors.greenAccent[500]}>
            Costo Total
          </Typography>
          <Typography variant="body1" color={colors.grey[100]}>
            {`$${purchase?.total_purchase_price}`}
          </Typography>
        </Box>
      </Box>

      {/* Divider */}
      <Divider sx={{ my: "20px", borderColor: colors.grey[700] }} />

      {/* Products List Section */}
      <Typography variant="h5" fontWeight="bold" mb="16px" color={colors.grey[100]}>
        Productos
      </Typography>
      <ProductsList productsList={purchase?.products} isReadOnly />
      <Box
        display="flex"
        justifyContent="end"
        gap="4px"
      >
        <SuccessButton label="Ver Compras" onClick={() => navigate('/purchases')}/>
      </Box>
    </Box>
  );
};

export default ViewPurchase;